import { render, staticRenderFns } from "./template-note-action.vue?vue&type=template&id=a0e7cdba"
import script from "./template-note-action.vue?vue&type=script&lang=js"
export * from "./template-note-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports